(function () {
  var root = document.querySelector('[data-evisa-checker]');
  if (!root) return;

  var dataUrl = root.getAttribute('data-evisa-src');
  var i18n = {};
  try {
    i18n = JSON.parse(root.querySelector('[data-evisa-i18n]').textContent);
  } catch (e) {
    i18n = {};
  }

  var passportSelect = root.querySelector('[data-evisa-passport]');
  var destSelect = root.querySelector('[data-evisa-destination]');
  var form = root.querySelector('[data-evisa-form]');
  var result = root.querySelector('[data-evisa-result]');
  var grid = root.querySelector('[data-evisa-issuers]');
  var fileForm = root.querySelector('[data-evisa-file]');
  var passportProp = root.querySelector('[data-evisa-prop-passport]');
  var destProp = root.querySelector('[data-evisa-prop-destination]');
  var statusProp = root.querySelector('[data-evisa-prop-status]');
  var locale = (document.documentElement.lang || 'fr').replace('_', '-');
  var names;
  var openPicker = null;

  try {
    names = new Intl.DisplayNames([locale, 'fr', 'en'], { type: 'region' });
  } catch (e) {
    names = null;
  }

  function countryName(code) {
    if (!code) return '';
    try {
      return names ? names.of(code) : code;
    } catch (e) {
      return code;
    }
  }

  function flagIso(code) {
    if (!code) return '';
    var map = { UK: 'gb' };
    return (map[code.toUpperCase()] || code).toLowerCase();
  }

  function flagUrl(code) {
    var iso = flagIso(code);
    if (!iso) return '';
    return 'https://flagcdn.com/w40/' + iso + '.png';
  }

  function flagHtml(code) {
    if (!code) return '';
    return '<img class="flag-img" src="' + flagUrl(code) + '" alt="" width="20" height="15" loading="lazy">';
  }

  function fillNativeSelect(select, codes, preferred) {
    var current = select.value;
    select.innerHTML = '';
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = select.getAttribute('data-placeholder') || '—';
    select.appendChild(placeholder);
    codes.forEach(function (code) {
      var option = document.createElement('option');
      option.value = code;
      option.textContent = countryName(code);
      select.appendChild(option);
    });
    if (preferred && codes.indexOf(preferred) !== -1) select.value = preferred;
    else if (current) select.value = current;
  }

  function closePicker(widget) {
    if (!widget) return;
    widget.classList.remove('is-open');
    if (openPicker === widget) openPicker = null;
  }

  function enhanceSelect(select, codes) {
    if (!select || select.closest('.flag-select')) return;
    var wrap = document.createElement('div');
    wrap.className = 'flag-select';
    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    select.classList.add('visually-hidden');
    select.tabIndex = -1;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'flag-select__btn';
    button.setAttribute('aria-haspopup', 'listbox');
    wrap.appendChild(button);

    var panel = document.createElement('div');
    panel.className = 'flag-select__panel';
    var search = document.createElement('input');
    search.type = 'search';
    search.className = 'flag-select__search';
    search.placeholder = select.getAttribute('data-placeholder') || '';
    search.setAttribute('autocomplete', 'off');
    var list = document.createElement('div');
    list.className = 'flag-select__list';
    list.setAttribute('role', 'listbox');
    panel.appendChild(search);
    panel.appendChild(list);
    wrap.appendChild(panel);

    function optionLabel(code) {
      return countryName(code);
    }

    function renderList(filter) {
      var q = (filter || '').toLowerCase().trim();
      list.innerHTML = '';
      codes.forEach(function (code) {
        var label = optionLabel(code);
        if (q && label.toLowerCase().indexOf(q) === -1 && code.toLowerCase().indexOf(q) === -1) return;
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'flag-select__option';
        item.setAttribute('role', 'option');
        item.setAttribute('data-code', code);
        if (select.value === code) item.classList.add('is-active');
        item.innerHTML = flagHtml(code) + '<span>' + label + '</span>';
        list.appendChild(item);
      });
    }

    function syncButton() {
      var code = select.value;
      if (!code) {
        button.innerHTML = '<span class="flag-select__placeholder">' + (select.getAttribute('data-placeholder') || '') + '</span>';
        return;
      }
      button.innerHTML = flagHtml(code) + '<span>' + optionLabel(code) + '</span>';
    }

    function setValue(code) {
      select.value = code || '';
      syncButton();
      select.dispatchEvent(new Event('change', { bubbles: true }));
      closePicker(wrap);
    }

    button.addEventListener('click', function () {
      var opening = !wrap.classList.contains('is-open');
      if (openPicker && openPicker !== wrap) closePicker(openPicker);
      wrap.classList.toggle('is-open', opening);
      openPicker = opening ? wrap : null;
      if (opening) {
        renderList('');
        search.value = '';
        search.focus();
      }
    });

    search.addEventListener('input', function () {
      renderList(search.value);
    });

    list.addEventListener('click', function (event) {
      var option = event.target.closest('[data-code]');
      if (!option) return;
      setValue(option.getAttribute('data-code'));
    });

    select._flagSelect = { setValue: setValue, syncButton: syncButton };
    syncButton();
  }

  document.addEventListener('click', function (event) {
    if (openPicker && !openPicker.contains(event.target)) closePicker(openPicker);
  });

  function lookup(data, passport, dest) {
    if (!passport || !dest) return '';
    if (passport === dest) return 's';
    var packed = data.p[passport];
    if (!packed) return '';
    var others = data.codes.filter(function (code) { return code !== passport; });
    var index = others.indexOf(dest);
    if (index < 0) return '';
    return packed.charAt(index) || '';
  }

  function statusCopy(code) {
    if (code === 'e') return { tone: 'ok', text: i18n.result_evisa };
    if (code === 'a') return { tone: 'ok', text: i18n.result_eta };
    if (code === 'o') return { tone: 'info', text: i18n.result_voa };
    if (code === 'f') return { tone: 'info', text: i18n.result_free };
    if (code === 'n') return { tone: 'warn', text: i18n.result_denied };
    if (code === 's') return { tone: 'info', text: i18n.result_same };
    return { tone: 'warn', text: i18n.result_required };
  }

  function renderResult(data) {
    var passport = passportSelect.value;
    var dest = destSelect.value;
    if (!passport || !dest) {
      result.hidden = true;
      if (fileForm) fileForm.hidden = true;
      return;
    }
    var code = lookup(data, passport, dest);
    var copy = statusCopy(code);
    result.hidden = false;
    result.className = 'evisa-result evisa-result--' + copy.tone;
    result.innerHTML =
      '<p class="evisa-result__route"><strong>' +
      flagHtml(passport) + ' ' + countryName(passport) +
      '</strong> → <strong>' +
      flagHtml(dest) + ' ' + countryName(dest) +
      '</strong></p><p>' + (copy.text || '') + '</p>';

    var canFile = code === 'e' || code === 'a';
    if (fileForm) {
      fileForm.hidden = !canFile;
      if (passportProp) passportProp.value = countryName(passport);
      if (destProp) destProp.value = countryName(dest);
      if (statusProp) statusProp.value = code === 'e' ? 'eVisa' : 'eTA';
    }
  }

  function renderIssuers(data) {
    if (!grid) return;
    grid.innerHTML = '';
    data.issuers.forEach(function (item) {
      var code = item[0];
      var count = item[1];
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'evisa-chip';
      button.setAttribute('data-dest', code);
      button.innerHTML =
        flagHtml(code) +
        '<span class="evisa-chip__name">' + countryName(code) + '</span>' +
        '<span class="evisa-chip__count">' + count + '</span>';
      grid.appendChild(button);
    });
  }

  fetch(dataUrl, { credentials: 'same-origin' })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      fillNativeSelect(passportSelect, data.codes, 'FR');
      fillNativeSelect(destSelect, data.codes, '');
      enhanceSelect(passportSelect, data.codes);
      enhanceSelect(destSelect, data.codes);
      renderIssuers(data);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        renderResult(data);
        if (!result.hidden) result.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      passportSelect.addEventListener('change', function () { renderResult(data); });
      destSelect.addEventListener('change', function () { renderResult(data); });
      grid.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-dest]');
        if (!chip) return;
        var code = chip.getAttribute('data-dest');
        if (destSelect._flagSelect) destSelect._flagSelect.setValue(code);
        else destSelect.value = code;
        renderResult(data);
        result.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    })
    .catch(function () {
      result.hidden = false;
      result.className = 'evisa-result evisa-result--warn';
      result.textContent = i18n.load_error || 'Impossible de charger les données eVisa.';
    });
})();
